import type React from "react";
import type { UseFormRegisterReturn } from "react-hook-form";

import style from "./Tiles.module.css";

interface TilesProps {
  registerAttrs: UseFormRegisterReturn;
  options: {
    icon: React.ReactNode;
    label: string;
    value: string;
  }[];
}

export const Tiles: React.FC<TilesProps> = ({ options, registerAttrs }) => {
  return (
    <>
      {options.map((option) => (
        <label key={option.value} className={style.tile}>
          <input {...registerAttrs} className={style.input} type="radio" value={option.value} />
          <div className={style.highlight} />
          <span className={style.icon}>{option.icon}</span>
          <span>{option.label}</span>
        </label>
      ))}
    </>
  );
};
